/* src/app/shared/components/not-authorized/not-authorized.component.scss */
/*# sourceMappingURL=not-authorized.component-UCINIT7Q.css.map */
